module.exports = __webpack_public_path__ + "img/PencilRulerButton.2848feaf.svg";